var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X_icon",
    clipPath: "url(#clip0_6154_356863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2928 0.117166C8.67109 0.703833 3.64794 4.40495 1.36442 9.6425C-0.107152 13.0238 -0.352059 16.9172 0.692848 20.5014C1.98351 24.9705 5.32218 28.7463 9.64218 30.6347C13.0235 32.1063 16.9168 32.3512 20.5013 31.3063C25.8662 29.7596 30.0904 25.3547 31.4771 19.8823C33.642 11.3065 28.3302 2.53786 19.7328 0.4905C17.8444 0.0424997 16.1813 -0.075047 14.2928 0.117166ZM14.5062 10.0265C15.8711 11.8398 17.0235 13.3332 17.0662 13.3332C17.1088 13.3332 18.5279 11.8398 20.2022 10.0265L23.2635 6.71983H25.0022L24.6288 7.11493C24.4155 7.33807 23.0288 8.84229 21.5462 10.4532C20.0635 12.0638 18.6128 13.6314 18.3244 13.9198L17.8128 14.4638L21.8128 19.7865C24.0102 22.7198 25.8128 25.1514 25.8128 25.1949C25.8128 25.2483 24.5013 25.2798 22.9111 25.2798L19.9995 25.2692L17.2902 21.6425C15.4235 19.1358 14.5488 18.0579 14.4635 18.1225C14.3995 18.1758 12.8844 19.8083 11.0928 21.7492L7.83951 25.2798H7.01775C6.55951 25.2798 6.18618 25.2581 6.18618 25.2265C6.18618 25.1949 7.88218 23.3381 9.95109 21.1092C12.0104 18.8798 13.7171 17.0132 13.7378 16.9816C13.7488 16.9381 12.0528 14.6238 9.97285 11.8398C7.89285 9.0665 6.18618 6.77317 6.18618 6.75141C6.18618 6.73071 7.49775 6.71983 9.10885 6.71983H12.0311L14.5062 10.0265Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.82154 8.14933C8.864 8.224 11.5514 11.8293 14.7731 16.1382L20.6398 23.9891L21.9514 24C22.7622 24 23.2531 23.9573 23.2314 23.8933C23.2215 23.84 20.544 20.2351 17.3015 15.8933L11.3914 8H10.0691C8.97088 8 8.74645 8.02176 8.82154 8.14933Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6154_356863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXRounded);
export default __webpack_public_path__ + "static/media/x-rounded.2313755d142221a0acc0db9e3d795b5e.svg";
export { ForwardRef as ReactComponent };